/* Willa global sticky CTA — reveal after hero scrolls out, or after 400px on pages without a hero. */
(function () {
  var el = document.getElementById("stickycta");
  if (!el) return;

  var hero =
    document.querySelector(".hero") ||
    document.querySelector(".page-hero") ||
    document.querySelector(".pdp-hero") ||
    document.querySelector("[data-hero]");

  function threshold() {
    if (!hero) return 400;
    return hero.offsetTop + hero.offsetHeight - 100;
  }

  function onScroll() {
    el.classList.toggle("visible", window.scrollY > threshold());
  }

  window.addEventListener("scroll", onScroll, { passive: true });
  window.addEventListener("resize", onScroll, { passive: true });
  onScroll();

  /* Fire willa:cta_click when the sticky CTA button is tapped, for analytics parity. */
  var link = el.querySelector("[data-sticky-cta-link]");
  if (link) {
    link.addEventListener("click", function () {
      try {
        document.dispatchEvent(
          new CustomEvent("willa:cta_click", {
            detail: { label: (link.textContent || "").trim(), target: link.getAttribute("href"), location: "sticky-cta" }
          })
        );
      } catch (e) {}
    });
  }
})();
